/* src/app/shared/components/quick-action/quick-action.component.scss */
.quickaction {
  z-index: 1000;
  position: absolute;
  opacity: 1;
  border-radius: 2px;
  background-color: #fafafa !important;
  box-shadow: 6px 6px 6px 0 rgba(0, 0, 0, 0.24);
  color: black;
  padding: 10px;
  animation: fadein 0.5s;
  max-width: 320px;
  min-width: 100px;
  border-radius: 2px;
}
.quickaction .body {
  font-size: 15px;
  background-color: black;
}
.quickaction .button {
  background-color: #fafafa;
  color: black;
  outline: none;
  border: none;
  width: 100%;
  text-align: left;
}
.quickaction .button:hover {
  background: #cccccc;
}
.arrow,
.arrow-bottom,
.arrow-top,
.arrow-right,
.arrow-left {
  animation: fadein 0.5s;
  position: absolute;
  width: 0;
  z-index: 1001;
}
.arrow-left {
  border-top: 10px solid transparent;
  border-bottom: 10px solid tran;
  border-right: 10px solid #fafafa !important;
}
.arrow-right {
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #fafafa !important;
}
.arrow-top {
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fafafa !important;
}
.arrow-bottom {
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fafafa !important;
}
/*# sourceMappingURL=quick-action.component.css.map */
